let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dB864")).then(() => parcelRequire('afv3s'));